import { ChangeDetectionStrategy, Component, DestroyRef, computed, inject, signal, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { ChatStore } from '@application/chat.store';
import { AuthStore } from '@application/auth.store';
import { KeyboardInsetService } from '@shared/viewport';
import { ChatListComponent } from '../chat-list/chat-list.component';
import { MessagePanelComponent } from '../message-panel/message-panel.component';
import { NoSelectedChatComponent } from '../no-selected-chat/no-selected-chat.component';
import { NewChatModalComponent } from '../new-chat-modal/new-chat-modal.component';

@Component({
  selector: 'app-chat-shell',
  imports: [
    CommonModule,
    ChatListComponent,
    MessagePanelComponent,
    NoSelectedChatComponent,
    NewChatModalComponent
  ],
  templateUrl: './chat-shell.component.html',
  styleUrl: './chat-shell.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChatShellComponent implements OnInit {
  private chatStore = inject(ChatStore);
  private auth = inject(AuthStore);
  private router = inject(Router);
  private keyboardInset = inject(KeyboardInsetService);
  private destroyRef = inject(DestroyRef);

  modalName = signal<string>('');
  readonly loggingOut = signal(false);
  readonly hasSelected = computed(() => this.chatStore.selectedChat() !== null);

  ngOnInit(): void {
    this.keyboardInset.attach(this.destroyRef);

    if (!this.auth.currentUser()) {
      this.router.navigate(['/login']);
      return;
    }

    this.chatStore.load();
  }

  onShowModal(name: string): void {
    this.modalName.set(name);
  }

  onBack(): void {
    this.chatStore.selectChat(null);
  }

  async onLogout(): Promise<void> {
    if (this.loggingOut()) return;

    this.loggingOut.set(true);
    let redirected = false;
    try {
      this.chatStore.reset();
      redirected = await this.auth.logout();
      if (!redirected) {
        await this.router.navigate(['/login']);
      }
    } finally {
      if (!redirected) this.loggingOut.set(false);
    }
  }
}
